module.exports = __webpack_public_path__ + "img/completion6.fae0c188.svg";